export const GET_CLICK_CONVERSION_PIXELS = "GET_CLICK_CONVERSION_PIXELS"
export const GET_CLICK_CONVERSION_PIXELS_SUCCESS = "GET_CLICK_CONVERSION_PIXELS_SUCCESS"
export const GET_CLICK_CONVERSION_PIXELS_ERROR = "GET_CLICK_CONVERSION_PIXELS_ERROR"

export const MODIFY_CLICK_CONVERSION_PIXELS = "MODIFY_CLICK_CONVERSION_PIXELS"
export const MODIFY_CLICK_CONVERSION_PIXELS_SUCCESS = "MODIFY_CLICK_CONVERSION_PIXELS_SUCCESS"
export const MODIFY_CLICK_CONVERSION_PIXELS_ERROR = "MODIFY_CLICK_CONVERSION_PIXELS_ERROR"

export const ADD_CLICK_CONVERSION_PIXEL = "ADD_CLICK_CONVERSION_PIXEL"
export const ADD_CLICK_CONVERSION_PIXEL_SUCCESS = "ADD_CLICK_CONVERSION_PIXEL_SUCCESS"
export const ADD_CLICK_CONVERSION_PIXEL_ERROR = "ADD_CLICK_CONVERSION_PIXEL_ERROR"

export const DELETE_CLICK_CONVERSION_PIXEL = "DELETE_CLICK_CONVERSION_PIXEL"
export const DELETE_CLICK_CONVERSION_PIXEL_SUCCESS = "DELETE_CLICK_CONVERSION_PIXEL_SUCCESS"
export const DELETE_CLICK_CONVERSION_PIXEL_ERROR = "DELETE_CLICK_CONVERSION_PIXEL_ERROR"

export const GET_CLICK_CONVERSION_PIXELS_AGG_AD_GROUPS = "GET_CLICK_CONVERSION_PIXELS_AGG_AD_GROUPS"
export const GET_CLICK_CONVERSION_PIXELS_AGG_AD_GROUPS_SUCCESS = "GET_CLICK_CONVERSION_PIXELS_AGG_AD_GROUPS_SUCCESS"
export const GET_CLICK_CONVERSION_PIXELS_AGG_AD_GROUPS_ERROR = "GET_CLICK_CONVERSION_PIXELS_AGG_AD_GROUPS_ERROR"

export const GET_CONVERSION_PIXELS_AGG_AD_GROUPS_V3 = "GET_CONVERSION_PIXELS_AGG_AD_GROUPS_V3"
export const GET_CONVERSION_PIXELS_AGG_AD_GROUPS_V3_SUCCESS = "GET_CONVERSION_PIXELS_AGG_AD_GROUPS_V3_SUCCESS"
export const GET_CONVERSION_PIXELS_AGG_AD_GROUPS_V3_ERROR = "GET_CONVERSION_PIXELS_AGG_AD_GROUPS_V3_ERROR"

export const GET_LEAD_CONVERSION_PIXELS_AGG_PROFILES = "GET_LEAD_CONVERSION_PIXELS_AGG_PROFILES"
export const GET_LEAD_CONVERSION_PIXELS_AGG_PROFILES_SUCCESS = "GET_LEAD_CONVERSION_PIXELS_AGG_PROFILES_SUCCESS"
export const GET_LEAD_CONVERSION_PIXELS_AGG_PROFILES_ERROR = "GET_LEAD_CONVERSION_PIXELS_AGG_PROFILES_ERROR"

export const GET_CALL_CONVERSION_PIXELS_AGG_PROFILES = "GET_CALL_CONVERSION_PIXELS_AGG_PROFILES"
export const GET_CALL_CONVERSION_PIXELS_AGG_PROFILES_SUCCESS = "GET_CALL_CONVERSION_PIXELS_AGG_PROFILES_SUCCESS"
export const GET_CALL_CONVERSION_PIXELS_AGG_PROFILES_ERROR = "GET_CALL_CONVERSION_PIXELS_AGG_PROFILES_ERROR"

export const GET_CLICK_CONVERSION_PIXELS_AGG_SOURCE_TYPES = "GET_CLICK_CONVERSION_PIXELS_AGG_SOURCE_TYPES"
export const GET_CLICK_CONVERSION_PIXELS_AGG_SOURCE_TYPES_SUCCESS = "GET_CLICK_CONVERSION_PIXELS_AGG_SOURCE_TYPES_SUCCESS"
export const GET_CLICK_CONVERSION_PIXELS_AGG_SOURCE_TYPES_ERROR = "GET_CLICK_CONVERSION_PIXELS_AGG_SOURCE_TYPES_ERROR"

export const GET_CONVERSION_PIXELS_AGG_SOURCE_TYPES_V3 = "GET_CONVERSION_PIXELS_AGG_SOURCE_TYPES_V3"
export const GET_CONVERSION_PIXELS_AGG_SOURCE_TYPES_V3_SUCCESS = "GET_CONVERSION_PIXELS_AGG_SOURCE_TYPES_V3_SUCCESS"
export const GET_CONVERSION_PIXELS_AGG_SOURCE_TYPES_V3_ERROR = "GET_CONVERSION_PIXELS_AGG_SOURCE_TYPES_V3_ERROR"

export const GET_LEAD_CONVERSION_PIXELS_AGG_SOURCE_TYPES = "GET_LEAD_CONVERSION_PIXELS_AGG_SOURCE_TYPES"
export const GET_LEAD_CONVERSION_PIXELS_AGG_SOURCE_TYPES_SUCCESS = "GET_LEAD_CONVERSION_PIXELS_AGG_SOURCE_TYPES_SUCCESS"
export const GET_LEAD_CONVERSION_PIXELS_AGG_SOURCE_TYPES_ERROR = "GET_LEAD_CONVERSION_PIXELS_AGG_SOURCE_TYPES_ERROR"

export const GET_CALL_CONVERSION_PIXELS_AGG_SOURCE_TYPES = "GET_CALL_CONVERSION_PIXELS_AGG_SOURCE_TYPES"
export const GET_CALL_CONVERSION_PIXELS_AGG_SOURCE_TYPES_SUCCESS = "GET_CALL_CONVERSION_PIXELS_AGG_SOURCE_TYPES_SUCCESS"
export const GET_CALL_CONVERSION_PIXELS_AGG_SOURCE_TYPES_ERROR = "GET_CALL_CONVERSION_PIXELS_AGG_SOURCE_TYPES_ERROR"

export const GET_CLICK_CONVERSION_PIXELS_AGG_CAMPAIGNS = "GET_CLICK_CONVERSION_PIXELS_AGG_CAMPAIGNS"
export const GET_CLICK_CONVERSION_PIXELS_AGG_CAMPAIGNS_SUCCESS = "GET_CLICK_CONVERSION_PIXELS_AGG_CAMPAIGNS_SUCCESS"
export const GET_CLICK_CONVERSION_PIXELS_AGG_CAMPAIGNS_ERROR = "GET_CLICK_CONVERSION_PIXELS_AGG_CAMPAIGNS_ERROR"

export const GET_CONVERSION_PIXELS_AGG_CAMPAIGNS_V3 = "GET_CONVERSION_PIXELS_AGG_CAMPAIGNS_V3"
export const GET_CONVERSION_PIXELS_AGG_CAMPAIGNS_V3_SUCCESS = "GET_CONVERSION_PIXELS_AGG_CAMPAIGNS_V3_SUCCESS"
export const GET_CONVERSION_PIXELS_AGG_CAMPAIGNS_V3_ERROR = "GET_CONVERSION_PIXELS_AGG_CAMPAIGNS_V3_ERROR"

export const GET_LEAD_CONVERSION_PIXELS_AGG_CAMPAIGNS = "GET_LEAD_CONVERSION_PIXELS_AGG_CAMPAIGNS"
export const GET_LEAD_CONVERSION_PIXELS_AGG_CAMPAIGNS_SUCCESS = "GET_LEAD_CONVERSION_PIXELS_AGG_CAMPAIGNS_SUCCESS"
export const GET_LEAD_CONVERSION_PIXELS_AGG_CAMPAIGNS_ERROR = "GET_LEAD_CONVERSION_PIXELS_AGG_CAMPAIGNS_ERROR"

export const GET_CALL_CONVERSION_PIXELS_AGG_CAMPAIGNS = "GET_CALL_CONVERSION_PIXELS_AGG_CAMPAIGNS"
export const GET_CALL_CONVERSION_PIXELS_AGG_CAMPAIGNS_SUCCESS = "GET_CALL_CONVERSION_PIXELS_AGG_CAMPAIGNS_SUCCESS"
export const GET_CALL_CONVERSION_PIXELS_AGG_CAMPAIGNS_ERROR = "GET_CALL_CONVERSION_PIXELS_AGG_CAMPAIGNS_ERROR"

export const ADD_CLICK_IMPORT_CONVERSION_PIXEL = "ADD_CLICK_IMPORT_CONVERSION_PIXEL"
export const ADD_CLICK_IMPORT_CONVERSION_PIXEL_SUCCESS = "ADD_CLICK_IMPORT_CONVERSION_PIXEL_SUCCESS"
export const ADD_CLICK_IMPORT_CONVERSION_PIXEL_ERROR = "ADD_CLICK_IMPORT_CONVERSION_PIXEL_ERROR"

export const GET_CLICK_CONVERSION_LOGS = "GET_CLICK_CONVERSION_LOGS"
export const GET_CLICK_CONVERSION_LOGS_SUCCESS = "GET_CLICK_CONVERSION_LOGS_SUCCESS"
export const GET_CLICK_CONVERSION_LOGS_ERROR = "GET_CLICK_CONVERSION_LOGS_ERROR"

export const GET_CLICK_CONVERSION_LOG_BY_ID = "GET_CLICK_CONVERSION_LOG_BY_ID"
export const GET_CLICK_CONVERSION_LOG_BY_ID_SUCCESS = "GET_CLICK_CONVERSION_LOG_BY_ID_SUCCESS"
export const GET_CLICK_CONVERSION_LOG_BY_ID_ERROR = "GET_CLICK_CONVERSION_LOG_BY_ID_ERROR"

export const RESET_CLICK_CONVERSION = "RESET_CLICK_CONVERSION"
export const RESET_RELOAD_CONVERSION_LOG = "RESET_RELOAD_CONVERSION_LOG"

export const GET_PRESIGNED_URL = "GET_PRESIGNED_URL"
export const UPLOAD_FILE_TO_URL = "UPLOAD_FILE_TO_URL"

export const GET_STATUS_OF_LOGS_BY_IDS = "GET_STATUS_OF_LOGS_BY_IDS"
export const GET_STATUS_OF_LOGS_BY_IDS_SUCCESS = "GET_STATUS_OF_LOGS_BY_IDS_SUCCESS"
export const GET_STATUS_OF_LOGS_BY_IDS_ERROR = "GET_STATUS_OF_LOGS_BY_IDS_ERROR"

export const DOWNLOAD_BULK_CONVERSIONS_FILE = 'DOWNLOAD_BULK_CONVERSIONS_FILE'
export const DOWNLOAD_BULK_CONVERSIONS_FILE_SUCCESS = 'DOWNLOAD_BULK_CONVERSIONS_FILE_SUCCESS'
export const DOWNLOAD_BULK_CONVERSIONS_FILE_ERROR = 'DOWNLOAD_BULK_CONVERSIONS_FILE_ERROR'

export const DELETE_CLICK_CONVERSION_LOG = "DELETE_CLICK_CONVERSION_LOG"
export const DELETE_CLICK_CONVERSION_LOG_SUCCESS = "DELETE_CLICK_CONVERSION_LOG_SUCCESS"
export const DELETE_CLICK_CONVERSION_LOG_ERROR = "DELETE_CLICK_CONVERSION_LOG_ERROR"